import { Boundary, Placement, Options } from '@popperjs/core'

export type TContextCardRenderType = 'default' | 'withBoundary'
export interface IPopperOptions {
  boundary?: Boundary
  placement?: Placement
}

export const popperConfig: Record<
  TContextCardRenderType,
  (option: IPopperOptions) => Partial<Options>
> = {
  /**
   * this is the original configuration context had before this change and probably is the renderType you need, at least you're having issues with this configuration
   */
  default: ({ placement = 'auto' }) => ({
    placement,
    strategy: 'fixed',
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          altAxis: true,
        },
      },
    ],
  }),
  /**
   * With this configuration you can setup a different element to set the boundaries of where the context card can be rendered
   * @example in the marketplace sometimes the context card is cutting off by the navbar, so you can set another element preventing this happens
   */
  withBoundary: ({ boundary, placement = 'auto' }) => ({
    placement,
    strategy: 'fixed',
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          altAxis: true,
          boundary,
        },
      },
    ],
  }),
}

export const getPopperConfig = (renderType: TContextCardRenderType) => {
  const config = popperConfig[renderType]

  if (!config) return popperConfig.default

  return config
}
